module.exports = __webpack_public_path__ + "static/img/jiaoshushi.2c9d1c0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jiaoshushi.gif
// module id = DSYL
// module chunks = 1